

















































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import User from '../../../store/entities/user'
import {
    GetOrgDepartmentList,
} from "../../../api/organization"
@Component
export default class CreateUser extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    user:any = {
        roleNames: [],
        surname: '123',
        isActive: true,
        deptIds:[],
    }
    deptlist:any = []
    async getSelect(){
        this.deptlist = (await GetOrgDepartmentList({QueryString:'',Status:true,PageSize:10000,Page:1})).items
    }
    get roles(){
        return this.$store.state.user.roles;
    }
    created(){
        console.log('roles', this.$store.state.user.roles)
        this.getSelect()
    }
    save(){
        (this.$refs.userForm as any).validate(async (valid:boolean)=>{
            if(valid){
                await this.$store.dispatch({
                    type:'user/create',
                    data:this.user
                });
                (this.$refs.userForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
            }
        })
    }
    cancel(){
        (this.$refs.userForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    validatePassCheck = (rule:any, value:any, callback:any) => {
        if (!value) {
            callback(new Error(this.L('ConfirmPasswordMsg')));
        } else if (value !== this.user.password) {
            callback(new Error(this.L('ConfirmPasswordNotMatch')));
        } else {
            callback();
        }
    };
    userRule={
        userName:[{required: true,message:this.L('FieldIsRequired',undefined,this.L('UserName')),trigger: 'blur'}],
        name:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('Name')),trigger: 'blur'}],
        emailAddress:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('Email')),trigger: 'blur'},{type: 'email'}],
        password:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('Password')),trigger: 'blur'}],
        confirmPassword:{validator:this.validatePassCheck,trigger: 'blur'},
        deptIds:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('Name')),trigger: 'change',type:'array'}],
    }
}
